import { useState } from 'react';

import { keepPreviousData } from '@tanstack/react-query';

import type { StoreSearchAppsSearchParams } from '@api';

import useOffsetPagination from '@shared/hooks/useOffsetPagination';

import { useStoreSearchAppsQuery } from '@query/store';

export const useSearchAppsQuery = ({
  limit = 30,
  find,
  offset = 0,
  category,
  subcategory,
  order,
  tags,
}: StoreSearchAppsSearchParams) => {
  const [offsetApp, setOffset] = useState(offset);
  const queryParams = {
    offset: offsetApp,
    find,
    category,
    subcategory,
    order,
    tags,
    limit: limit,
  };
  const query = useStoreSearchAppsQuery(queryParams, {
    placeholderData: keepPreviousData,
  });
  const pagination = useOffsetPagination({
    totalItems: +(query?.data?.total_apps || 0),
    offset: offsetApp,
    setOffset,
    itemsPerPage: limit,
  });

  return {
    ...query,
    pagination,
  };
};
